export default __webpack_public_path__ + "static/0084-0b1ab9b4546cc4724c7564725be17921.png";